import React from "react";
import { Link } from "react-router-dom";
import { Orbit } from "lucide-react";

const cols = [
  {
    title: "The App",
    links: [
      { to: "/businesses", label: "For Businesses" },
      { to: "/creators", label: "For Creators" },
      { to: "/how-it-works", label: "How It Works" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/privacy", label: "Privacy" },
      { to: "/terms", label: "Terms" },
      { to: "/contact", label: "Contact" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer className="border-t border-white/10 mt-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2 max-w-sm">
            <Link to="/" className="flex items-center gap-2">
              <span className="grid place-items-center h-8 w-8 rounded-lg bg-gradient-to-br from-sky-500 to-blue-600">
                <Orbit size={18} className="text-white" />
              </span>
              <span className="font-display font-bold text-lg text-white">Neo Orbit</span>
            </Link>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">
              Building smarter infrastructure for creator-led marketing.
            </p>
            <div className="mt-6 pt-5 border-t border-white/10 max-w-xs" data-testid="footer-founder">
              <p className="eyebrow">Founded by</p>
              <p className="mt-2 font-display text-xl font-bold text-white tracking-tight">SAVI</p>
              <p className="mt-0.5 text-xs text-slate-500">Founder &amp; CEO, Neo Orbit</p>
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <p className="eyebrow">{c.title}</p>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-sm text-slate-400 hover:text-white transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Neo Orbit. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="mailto:founder@neoorbit.co" data-testid="footer-contact-email" className="text-xs text-slate-400 hover:text-sky-300 transition-colors">founder@neoorbit.co</a>
            <p className="text-xs text-slate-600 font-mono">Orbit · Private Beta</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
